import { plainToClass } from 'class-transformer';
import { validate } from 'class-validator';

export default async <S, P>(
  Schema: new (...args: unknown[]) => S,
  payload: P,
): Promise<{[key: string]: string}> => {
  const plain = plainToClass(Schema, payload);
  const errors = await validate(plain);
  if (errors.length) {
    // console.log(errors);
    return errors.reduce(
      (ers, error) => ({
        ...ers,
        [error.property]: Object.values(error.constraints || {})[0],
      }),
      {},
    );
  }
  return {};
};
